import { type LicenseStatus } from "@clipboard-health/contract-worker-app-bff";
import { Pill, type PillSize } from "@src/appV2/redesign/system/ui-components";
import type { IntentVariant } from "@src/appV2/redesign/system/ui-theme";

interface LicenseStatusPillProps {
  status: LicenseStatus;
  size?: PillSize;
}

const INTENT_BY_STATUS: Record<LicenseStatus, IntentVariant> = {
  PENDING: "neutral",
  EXPIRED: "error",
  REJECTED: "error",
  ACTIVE: "success",
  EXPIRING: "warning",
  ARCHIVED: "error",
};

const STATUS_LABELS: Record<LicenseStatus, string> = {
  PENDING: "In review",
  EXPIRED: "Expired",
  REJECTED: "Rejected",
  ACTIVE: "Active",
  EXPIRING: "Expiring",
  ARCHIVED: "Deleted",
};

export function LicenseStatusPill(props: LicenseStatusPillProps) {
  const { status, size = "small" } = props;

  const intent = INTENT_BY_STATUS[status];

  return (
    <Pill
      size={size}
      variant="filled"
      label={STATUS_LABELS[status]}
      backgroundColor={(theme) => theme.palette.intent?.[intent].background}
      color={(theme) => theme.palette.intent?.[intent].text}
      iconColor={(theme) => theme.palette.intent?.[intent].icon}
    />
  );
}
